import { useLayoutEffect } from 'react';

import { IUseFabric } from './types';

export const useSelection = (props: IUseFabric) => {
  const { ref, context } = props;
  const { annotationEnabled } = context;

  useLayoutEffect(() => {
    const canvas = ref.current;
    canvas.selection = annotationEnabled;
    canvas.requestRenderAll();
  }, [ref, annotationEnabled]);
}
